module.exports = __webpack_public_path__ + "img/diy-password.2d1fb625.svg";